import React, { Component } from "react";
import Axios from "axios";
import ListAlerts from "./ListAlerts.js";
import ListIsolated from "./ListIsolated.js";
import IsolatedMarker from "./Marker.js";
import InfoBox from "./InfoBox.js";
import * as Constants from "../../consts/Constants.js";
import { MapContainer, TileLayer } from "react-leaflet";

const MAX_HOURS_BEFORE_ALERT = 4;
const MAX_HOURS_BEFORE_OUTDATED = 24;

class Quarentine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userStates: [],
      selected: null,
      list: [],
      center: {
        lat: Constants.LATITUD_AYACUCHO,
        lng: Constants.LONGITUD_AYACUCHO,
      },
    };

    this.map = null;

    this.clickOnMarker = this.clickOnMarker.bind(this);
    this.pingAction = this.pingAction.bind(this);
  }

  onMapCreated(map) {
    map.setOptions({
      disableDefaultUI: true,
    });
  }

  componentDidMount() {
    this.loadData();
    this.timer = setInterval(() => this.loadData(), 10000);
  }

  setMap(map) {
    this.map = map;
  }

  onDragEnd(e) {}

  onCloseClick() {}

  onClick(e) {}

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  pingAction = (userId) => {
    Axios.post(Constants.FINAL_URL_QUARENTINE + userId + Constants.URL_PING)
      .then((response) => {})
      .catch(function (error) {
        console.log(error);
      });
  };

  loadData() {
    Axios.get(Constants.FINAL_URL_QUARENTINE)
      .then((response) => {
        let list = [];
        response.data.forEach((item, i) => {
          item.hasLocation = function () {
            return this.state != null && this.state.location !== undefined;
          };

          item.isQuiet = function () {
            return (
              this.state != null && this.state.currentMovement.type === "VISIT"
            );
          };

          item.isMoving = function () {
            return (
              (this.state != null &&
                this.state.currentMovement.type === "COMMUTE") ||
              (!this.isQuiet() && this.hasLocation())
            );
          };

          item.isUpdated = function () {
            if (this.state == null) return false;
            var diff = new Date().getTime() - this.state.reportTime;
            var horas = Math.floor(diff / 1000 / 60 / 60);
            return horas < MAX_HOURS_BEFORE_ALERT;
          };

          item.isOutDated = function () {
            if (this.state == null) return false;
            var diff = new Date().getTime() - this.state.reportTime;
            var horas = Math.floor(diff / 1000 / 60 / 60);
            return horas >= MAX_HOURS_BEFORE_OUTDATED;
          };

          if (item.state !== undefined) {
            if (item.isMoving()) list.push(item);
          }
        });

        response.data.sort(function (userA, userB) {
          var a = userA.isMoving()
            ? 3
            : !userA.hasLocation() || userA.isOutDated()
            ? 2
            : userA.isUpdated()
            ? 0
            : 1;
          var b = userB.isMoving()
            ? 3
            : !userB.hasLocation() || userB.isOutDated()
            ? 2
            : userB.isUpdated()
            ? 0
            : 1;
          return b - a;
        });

        this.setState({
          userStates: response.data,
          selected: this.state.selected,
          list: list,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  clickOnMarker(userState) {
    let newCenter = this.state.center;
    if (userState.state != null && userState.state.location !== undefined) {
      newCenter = {
        lat: userState.state.location.latitude,
        lng: userState.state.location.longitude,
      };
      this.map.setView([newCenter.lat, newCenter.lng], 18);
    }
    this.setState({
      userStates: this.state.userStates,
      selected: userState,
      center: newCenter,
    });
  }

  render() {
    var infoBox = null;
    if (this.state.selected != null)
      infoBox = (
        <InfoBox
          userState={this.state.selected.state}
          name={this.state.selected.profile.name}
          lastName={this.state.selected.profile.lastName}
          pingButton={true}
          pingAction={this.pingAction}
        />
      );

    return (
      <div
        style={{
          display: "flex",
          height: "85%",
          width: "90%",
          position: "absolute",
        }}
      >
        <ListIsolated
          users={this.state.userStates}
          clickOnMarker={this.clickOnMarker}
        />

        <div style={{ height: "100%", width: "70%", overflow: "hidden" }}>
          <MapContainer
            style={{
              height: "100%",
              width: "100%",
              overflow: "hidden",
              zIndex: 399,
            }}
            center={[this.state.center.lat, this.state.center.lng]}
            zoom={13}
            scrollWheelZoom={true}
            whenCreated={this.setMap.bind(this)}
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {this.state.userStates.map((userState, index) =>
              userState.state !== undefined &&
              userState.state.location !== undefined ? (
                <IsolatedMarker
                  userState={userState}
                  key={userState.userId}
                  lat={userState.state.location.latitude}
                  lng={userState.state.location.longitude}
                  clickcall={this.clickOnMarker.bind(this)}
                />
              ) : null
            )}
          </MapContainer>
          {infoBox}
        </div>
        <ListAlerts alerts={this.state.list} />
      </div>
    );
  }
}

export default Quarentine;
